<template>
  <div>
    <!-- 管理员添加和详情弹框开始 -->
    <el-dialog :close-on-click-modal="false"
      :title="titleType"
      :visible.sync="addInfoVisible"
      :before-close="addInfoHandleClose"
      width="32.3%"
      center
    >
      <el-divider></el-divider>

      <div class="addInfoFrom">
        <el-form ref="form" :model="form" :rules="rules" label-width="120px">
          <el-form-item label="用户名:" prop="UserName">
            <el-input v-model="form.UserName" placeholder="请输入用户名"></el-input>
          </el-form-item>
          <el-form-item label="真实姓名:"  prop="Name">
            <el-input v-model="form.Name" placeholder="请输入真实姓名"></el-input>
          </el-form-item>
          <el-form-item label="手机号:" prop="Phone">
            <el-input v-model="form.Phone" placeholder="请输入手机号"></el-input>
          </el-form-item>
          <el-form-item label="密码:" >
            <el-input v-model="form.Password" placeholder="请输入密码" show-password clearable></el-input>
          </el-form-item>
          <el-form-item label="确认密码:" >
            <el-input v-model="form.sure_Password" placeholder="请输入联系电话" show-password clearable></el-input>
          </el-form-item>
          <el-form-item label="E-mail:"  prop="E_mail">
            <el-input v-model="form.E_mail" placeholder="请输入邮箱"></el-input>
          </el-form-item>
          <el-form-item label="所属角色:" prop="RoleID">
            <el-select v-model="form.RoleID" placeholder="请选择">
              <el-option
                v-for="item in options"
                :key="item.id"
                :label="item.title"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <div class="btn">
              <el-button @click="clearUserInput">清空</el-button>
              <el-button class="btnL" @click="submitForm('form')">{{ ids?'确认修改':'确认添加' }} </el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
    <!-- 管理员添加和详情弹框结束 -->
    <!-- 角色添加和修改弹框开始 -->
    <el-dialog :close-on-click-modal="false"
      :title="titleStyle"
      :visible.sync="addRoleVisible"
      :before-close="addRoleHandleClose"
      width="27%"
      center
    >
      <el-divider></el-divider>

      <div class="addRoleFrom">
        <el-form ref="formR" :model="formRole" label-width="100px" :rules="rolerules">
          <el-form-item label="角色名称:" prop="title">
            <el-input v-model="formRole.title" placeholder="请输入角色名称"></el-input>
          </el-form-item>
          <el-form-item label="角色描述:" prop="description">
            <el-input type="textarea" v-model="formRole.description" placeholder="请输入角色描述"></el-input>
          </el-form-item>
          <el-form-item label="是否启用:" prop="status">
            <el-radio-group v-model="formRole.status">
              <el-radio label="1">启用</el-radio>
              <el-radio label="0">未启用</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item>
            <div class="btn">
              <el-button @click="clearInput">清空</el-button>
              <el-button class="btnL" @click="subim('formR')">{{ roleid?'确认修改':'确认添加' }} </el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
    <!-- 管理员添加和修改弹框结束 -->
  </div>
</template>

<script>

import {
  getDistrbutorUserInfo,
  getDistrbutorUserRoleList,
  addDistrbutorUser,
  updateDistrbutorUser,
  addDistrbutorUserRole,
  updateDistrbutorUserRole,
  getDistrbutorUserRoleInfo
} from '@/request/distributor.js'
import { Message } from 'element-ui';
export default {
  props:['ids','roleid'],
  data() {
    var checkPhone = (rule, value, callback) => {
			if (value === '') {
        callback(new Error('手机号不能为空'))
      } else if (!/^1\d{10}$/.test(value)) {
        callback(new Error('手机号格式错误'))
      } else {
        callback()
      }
		};
    return {
      titleType: "", // 区分管理员添加和详情
      titleStyle: "", // 区分角色添加和详情
      addInfoVisible: false, // 添加管理员和详情
      addRoleVisible: false, // 添加角色和详情
      form: {
        token:window.sessionStorage.getItem('Token'),
        UserName:"", // 用户名
        Password:"",//密码
        sure_Password:'',//确认密码
        Name:'',//真实名称
        Phone:'',//手机号
        E_mail:'',//	邮箱
        UserID:'',//	用户id
        RoleID:'',//	角色id
      },
      options: [
      ],
      value: "",
      radio: "",
      rules:{
        UserName: [{ required: true, message: '请输入用户名', trigger: 'blur' }, ],
        Name: [{ required: true, message: '请输入真实名字', trigger: 'blur' }, ],
        Phone: [{ validator: checkPhone, required: true, trigger: 'blur' } ],
        E_mail: [{ required: true, message: '请输入邮箱号', trigger: 'blur' }, ],
        RoleID: [  { required: true, message: '请选择角色', trigger: 'change' } ],
      },
      formRole:{
        token:window.sessionStorage.getItem('Token'),
        title:"",
        id:'',
        description:"",
        status:'1'
      },
      rolerules:{
        title: [{ required: true, message: '请输入标题', trigger: 'blur' }, ],
        description: [{ required: true, message: '请输入描述', trigger: 'blur' }, ],
        status: [  { required: true, message: '请选择状态', trigger: 'change' } ],
      }
    };
  },
  created(){
    let d = {
      token:window.sessionStorage.getItem('Token'),
    }
    getDistrbutorUserRoleList(d).then(res=>{
        if(res.data.status=='ok'){
          this.options = res.data.result.data
          this.options.push({
            id:1,
            title:'超级管理员'
          })
        }
    })
    if(this.ids){
      this.getdetail()
    }
    if(this.roleid){
      this.getroleDeta()
    }
  },
  methods: {
    clearUserInput(){
        this.form.token = window.sessionStorage.getItem('Token'),
        this.form.UserName = ""   // 用户名
        this.form.Password = ""  //密码
        this.form.sure_Password = ''  //确认密码
        this.form.Name = ''  //真实名称
        this.form.Phone = ''  //手机号
        this.form.E_mail = ''  //	邮箱
        this.form.RoleID = ''  //	角色id
    },
    clearInput(){
      this.formRole.title = ""
      this.formRole.description=''
      this.formRole.status = '1'
    },
    getdetail(){
      let data = {
        token:window.sessionStorage.getItem('Token'),
        UserID:this.ids
      }
      getDistrbutorUserInfo(data).then(res=>{
        if(res.data.status=='ok'){
          this.form = {
              token:window.sessionStorage.getItem('Token'),
              UserName:res.data.result.UserName, // 用户名
              Password:'',//密码
              sure_Password:'',//确认密码
              Name:res.data.result.Name,//真实名称
              Phone:res.data.result.Phone,//手机号
              E_mail:res.data.result.E_mail,//	邮箱
              UserID:res.data.result.UserID,//	用户id
              RoleID:res.data.result.RoleID,//	角色id
            }
        }
      })
    },
    submitForm(formName){
      if(this.form.Password&&this.form.sure_Password){
        if(this.form.Password!=this.form.sure_Password){
          Message.error('两次密码不一致')
          return false
          return false
        }
      }
      this.$refs[formName].validate((valid) => {
          if (valid) {
            if(this.form.UserID){
              updateDistrbutorUser(this.form).then(res=>{
                if(res.data.status=='ok'){
                  Message.success('修改成功')
                  this.$emit('addclose')
                }else{
                  Message.error(res.data.msg)
                }
              })
            }else{
              addDistrbutorUser(this.form).then(res=>{
              if(res.data.status=='ok'){
                  Message.success('添加成功')
                  this.$emit('addclose')
                }else{
                  Message.error(res.data.msg)
                }
              })
            }
           
          } else {
            return false;
          }
      });
    },
    getroleDeta(){
      let data = {
        id:this.roleid,
        token:window.sessionStorage.getItem('Token')
      }
      getDistrbutorUserRoleInfo(data).then(res=>{
        if(res.data.status=='ok'){
          this.formRole = {
            token:window.sessionStorage.getItem('Token'),
            title:res.data.result.title,
            id:res.data.result.id,
            description:res.data.result.description,
            status:res.data.result.status + ''
          }
        }
      })
    },
    subim(formName){
      this.$refs[formName].validate((valid) => {
          if (valid) {
            console.log(this.roleid)
            if(this.roleid){
              this.formRole.id = this.roleid
              updateDistrbutorUserRole(this.formRole).then(res=>{
                if(res.data.status=='ok'){
                  this.$emit('roleClose')
                  Message.success('修改成功')
                }else{
                  Message.error(res.data.msg)
                }
              })
            }else{
              addDistrbutorUserRole(this.formRole).then(res=>{
                if(res.data.status=='ok'){
                  this.$emit('roleClose')
                  Message.success('添加成功')
                }else{
                  Message.error(res.data.msg)
                }
              })
            }
         
          } else {
            return false;
          }
      });
    },
    // 角色添加和修改
    addRole(row) {
      if (row) {
        this.titleStyle = "角色修改";
      } else {
        this.titleStyle = "添加角色";
      }
      this.addRoleVisible = true;
    },
    // 角色添加和修改X
    addRoleHandleClose() {
      this.$emit('roleClose')
      this.addRoleVisible = false;
    },
    // 管理员添加和详情
    addDefail(row) {
      console.log(row)
      if (row.UserID) {
        this.titleType = "管理员详情修改";
      } else {
        this.titleType = "添加管理员";
      }
      this.addInfoVisible = true;
    },
    // 管理员添加和详情X
    addInfoHandleClose() {
      this.addInfoVisible = false;
      this.$emit('addclose')
    }
  }
};
</script>

<style lang='less' scoped>
.addRoleFrom {
  .btn {
    display: flex;
    justify-content: center;
    margin-left: -80px;
    margin-top: 10px;
    .el-button {
      width: 100px;
      border: none;
      background: #d9d9d9;
      border-radius: 4px;
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      text-align: center;
      color: #ffffff;
    }
    .btnL {
      width: 100px;
      border: none;
      background: #246deb;
      border-radius: 4px;
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      text-align: center;
      color: #ffffff;
      margin-left: 20px;
    }
  }
  /deep/.el-form-item__label {
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: right;
    color: #666666;
  }
  .el-form-item {
    position: relative;
  }
  .xingA {
    position: absolute;
    top: 0px;
    left: -78px;
    color: #ff4d4f;
  }
}
.addInfoFrom {
  .btn {
    display: flex;
    justify-content: center;
    margin-left: -80px;
    margin-top: 20px;
    .el-button {
      width: 100px;
      border: none;
      background: #d9d9d9;
      border-radius: 4px;
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      text-align: center;
      color: #ffffff;
    }
    .btnL {
      width: 100px;
      border: none;
      background: #246deb;
      border-radius: 4px;
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      text-align: center;
      color: #ffffff;
      margin-left: 20px;
    }
  }
  /deep/.el-form-item__label {
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: right;
    color: #666666;
  }
  .el-form-item {
    position: relative;
  }
  .xingA {
    position: absolute;
    top: 0px;
    left: -63px;
    color: #ff4d4f;
  }
  .xingB {
    position: absolute;
    top: 0px;
    left: -78px;
    color: #ff4d4f;
  }
  .xingC {
    position: absolute;
    top: 0px;
    left: -63px;
    color: #ff4d4f;
  }
  .xingD {
    position: absolute;
    top: 0px;
    left: -50px;
    color: #ff4d4f;
  }
}
/deep/.el-dialog__body {
  padding: 0px 20px 20px;
}

// 弹框标题设置
/deep/.el-dialog__title {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

/deep/.el-icon-close {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

// 分割线
/deep/.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
}
/deep/ .el-dialog{
  min-width: 400px;
}
.addRoleFrom /deep/.el-radio__label{
  color: #000000;
}
</style>